import { PbECommerceSettingsUseCaseEnum } from '@itsrever/rever-api'
import { useAppSelector } from '@/redux/hooks'
import { ItemSelection } from '@/app/item-selection/item-selection'
import { LiteItemSelection } from '@/app/lite/lite-item-selection'

function ItemSelectionPage() {
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  const isReverLite = settings.use_case === PbECommerceSettingsUseCaseEnum.Lite

  if (isReverLite) {
    return <LiteItemSelection />
  }

  return <ItemSelection />
}

export default ItemSelectionPage
